{
  "v2.profils.code.BROUILLON_VIDE": "Rien à soumettre : ce brouillon est vide.",
  "v2.profils.code.CONFIRMATION_IDENTITE_ECHOUEE": "Identité non confirmée : secret incorrect.",
  "v2.profils.code.CONFIRMATION_IDENTITE_REQUISE": "Confirmation d’identité requise.",
  "v2.profils.code.CONFLIT_CONCURRENT": "Le profil a changé depuis votre lecture : rechargez-le avant de continuer.",
  "v2.profils.code.CONTEXTE_INCOMPLET": "Le contexte nécessaire à la vérification des droits est incomplet.",
  "v2.profils.code.DELAI_DE_REFLEXION_EN_COURS": "Le délai de réflexion n’est pas écoulé.",
  "v2.profils.code.DROIT_ISOLE_INTROUVABLE": "Ce droit isolé n’existe plus.",
  "v2.profils.code.DROIT_NON_PROPOSABLE": "Un droit choisi ne se pose pas sur un profil.",
  "v2.profils.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire.",
  "v2.profils.code.EMPREINTE_PERIMEE": "La révision a changé depuis sa soumission : relisez-la.",
  "v2.profils.code.ETAT_INVALIDE": "Ce geste n’est pas possible dans l’état actuel du profil.",
  "v2.profils.code.MOTIF_TROP_COURT": "Le motif compte au moins 15 caractères.",
  "v2.profils.code.PROFIL_DEPART_NON_MODIFIABLE": "Un profil de départ n’est pas modifiable : dupliquez-le.",
  "v2.profils.code.PROFIL_DEPART_NON_RETIRABLE": "Un profil de départ ne se retire pas.",
  "v2.profils.code.PROFIL_INTROUVABLE": "Ce profil est introuvable.",
  "v2.profils.code.PROFIL_NIVEAU_INCOMPATIBLE": "Un droit choisi ne se pose pas sur un profil de ce niveau.",
  "v2.profils.code.PROFIL_NOM_DEJA_PRIS": "Ce nom de profil est déjà pris.",
  "v2.profils.code.PROFIL_TENU": "Ce profil est tenu par des personnes : retirez-le d’abord.",
  "v2.profils.code.RETRAIT_RESERVE_A_L_AUTEUR": "Seule la personne qui a soumis peut retirer sa soumission.",
  "v2.profils.code.TROP_DE_TENTATIVES": "Trop de tentatives : réessayez plus tard.",
  "v2.profils.code.VALIDATION_ERROR": "Un filtre est invalide.",
  "v2.profils.code.VALIDATION_PAR_UN_TIERS": "Validation par une autre personne requise.",
  "v2.profils.code.VERSION_FIGEE": "Cette révision est figée : elle ne se modifie plus.",
  "v2.profils.code.VERSION_INTROUVABLE": "Cette version du profil est introuvable.",
  "v2.profils.col.actions": "Actions",
  "v2.profils.col.etat": "État",
  "v2.profils.col.niveau": "Niveau",
  "v2.profils.col.nom": "Nom",
  "v2.profils.col.origine": "Origine",
  "v2.profils.col.personnes": "Personnes qui le tiennent",
  "v2.profils.creer": "Créer un profil",
  "v2.profils.depart.duplicable": "non modifiable, duplicable",
  "v2.profils.editeur.annule_validation": "Toute modification enregistrée annule une validation en cours.",
  "v2.profils.editeur.confirmation.aide": "Confirmation d’identité exigée pour ce geste ; le secret n’est pas conservé.",
  "v2.profils.editeur.confirmation.publier": "Mot de passe ou code de second facteur (publier)",
  "v2.profils.editeur.confirmation.requise.publier": "Confirmez votre identité pour publier.",
  "v2.profils.editeur.confirmation.requise.valider": "Confirmez votre identité pour valider.",
  "v2.profils.editeur.confirmation.valider": "Mot de passe ou code de second facteur (valider)",
  "v2.profils.editeur.contenu": "Contenu du profil",
  "v2.profils.editeur.decision": "Décision",
  "v2.profils.editeur.delai": "Délai de réflexion en cours jusqu’au {{date}}.",
  "v2.profils.editeur.droits": "Droits du profil",
  "v2.profils.editeur.droits.non_proposes": "Les droits réservés au propriétaire et les droits personnels ne sont pas proposés.",
  "v2.profils.editeur.ecarts": "Écarts avec la version publiée",
  "v2.profils.editeur.ecarts.ajoutes": "Droits ajoutés : {{droits}}",
  "v2.profils.editeur.ecarts.aucun": "Aucune autre version publiée : aucun écart.",
  "v2.profils.editeur.ecarts.personnes": "{{n}} personnes touchées",
  "v2.profils.editeur.ecarts.retires": "Droits retirés : {{droits}}",
  "v2.profils.editeur.echec": "Le geste n’a pas abouti.",
  "v2.profils.editeur.enregistre": "Brouillon enregistré.",
  "v2.profils.editeur.enregistrer": "Enregistrer le brouillon",
  "v2.profils.editeur.enregistrer_avant": "Enregistrez le brouillon avant de le soumettre.",
  "v2.profils.editeur.etat": "État de publication",
  "v2.profils.editeur.fermer": "Fermer",
  "v2.profils.editeur.fige": "Révision soumise, figée par son empreinte ({{empreinte}}…) : aucune modification possible.",
  "v2.profils.editeur.motif": "Motif du refus",
  "v2.profils.editeur.motif_refus": "Refusé : {{motif}}",
  "v2.profils.editeur.nature": "Nature du profil",
  "v2.profils.editeur.nature.administration": "Copie d’un profil d’administration : héritée vers le bas, elle peut y être remplacée.",
  "v2.profils.editeur.nature.travail": "Profil de travail : un profil posé plus bas le remplace.",
  "v2.profils.editeur.niveau": "Niveau du profil",
  "v2.profils.editeur.nom": "Nom du profil",
  "v2.profils.editeur.nom.requis": "Donnez un nom au profil.",
  "v2.profils.editeur.nouveau": "Nouveau profil",
  "v2.profils.editeur.prerequis": "Prérequis de lecture ajoutés : {{droits}}.",
  "v2.profils.editeur.publication": "Publication",
  "v2.profils.editeur.publier": "Publier",
  "v2.profils.editeur.refuse": "Révision refusée.",
  "v2.profils.editeur.refuser": "Refuser",
  "v2.profils.editeur.relue_autre": "Le profil a été modifié ailleurs pendant votre saisie : votre saisie est gardée ; enregistrer peut être refusé, rechargez pour reprendre la version lue.",
  "v2.profils.editeur.retire_lecture_seule": "Profil retiré : consultation seule.",
  "v2.profils.editeur.retire_validation": "Soumission retirée : la révision est de nouveau un brouillon.",
  "v2.profils.editeur.retirer_validation": "Retirer de la validation",
  "v2.profils.editeur.separation": "Séparation des tâches",
  "v2.profils.editeur.separation.alerte": "Combinaison signalée : {{creer}} avec {{approuver}} ; sans effet sur la règle de validation par un tiers.",
  "v2.profils.editeur.separation.aucune": "Aucune combinaison à signaler.",
  "v2.profils.editeur.soumettre": "Soumettre à validation",
  "v2.profils.editeur.supprimer": "Supprimer le brouillon",
  "v2.profils.editeur.supprimer.consequence": "Le brouillon est supprimé ; un profil jamais publié disparaît avec lui.",
  "v2.profils.editeur.supprimer.titre": "Supprimer le brouillon {{nom}} ?",
  "v2.profils.editeur.supprimer.verbe": "Supprimer",
  "v2.profils.editeur.titre": "Profil — éditeur",
  "v2.profils.editeur.valide": "Révision validée.",
  "v2.profils.editeur.valider": "Valider",
  "v2.profils.etat.chargement": "Chargement : {{quoi}}…",
  "v2.profils.etat.erreur": "Lecture impossible : {{quoi}}.",
  "v2.profils.etat.reessayer": "Réessayer",
  "v2.profils.etat.refus": "Lecture refusée : {{quoi}}.",
  "v2.profils.etat_profil.brouillon": "Brouillon",
  "v2.profils.etat_profil.en_validation": "En validation",
  "v2.profils.etat_profil.publie": "Publié",
  "v2.profils.etat_profil.refuse": "Refusé",
  "v2.profils.etat_profil.retire": "Retiré",
  "v2.profils.etat_profil.valide": "Validé",
  "v2.profils.fiche.chargement": "Chargement du profil…",
  "v2.profils.fiche.de_l_organisation": "Profil de l’organisation",
  "v2.profils.fiche.depart": "Profil de départ de la plateforme, non modifiable",
  "v2.profils.fiche.depart_non_modifiable": "Profil de départ non modifiable : dupliquez-le.",
  "v2.profils.fiche.depart_non_retirable": "Un profil de départ ne se retire pas.",
  "v2.profils.fiche.droits": "Droits du profil",
  "v2.profils.fiche.droits.reserves": "Les droits réservés au propriétaire ne figurent jamais dans un profil.",
  "v2.profils.fiche.droits.vide": "Aucun droit.",
  "v2.profils.fiche.dupliquer": "Dupliquer le profil",
  "v2.profils.fiche.dupliquer.aide": "La copie est un brouillon de l’organisation ; les droits réservés ne sont jamais copiés.",
  "v2.profils.fiche.dupliquer.echec": "Le profil n’a pas été dupliqué.",
  "v2.profils.fiche.dupliquer.nom": "Nom de la copie",
  "v2.profils.fiche.erreur": "Le profil n’a pas pu être chargé.",
  "v2.profils.fiche.heritage": "Héritage",
  "v2.profils.fiche.modifier": "Modifier le profil",
  "v2.profils.fiche.motif_chargement": "Lecture du motif…",
  "v2.profils.fiche.motif_illisible": "Le motif du refus n’a pas pu être lu.",
  "v2.profils.fiche.motif_refus": "Motif du refus",
  "v2.profils.fiche.nouvelle_version": "Nouvelle version en brouillon",
  "v2.profils.fiche.personnes": "Personnes qui le tiennent",
  "v2.profils.fiche.personnes.vide": "Personne ne tient ce profil.",
  "v2.profils.fiche.refus": "Vous ne pouvez pas lire ce profil.",
  "v2.profils.fiche.reprendre_refuse": "Reprendre mon brouillon refusé",
  "v2.profils.fiche.retire": "Profil retiré.",
  "v2.profils.fiche.retirer": "Retirer le profil",
  "v2.profils.fiche.retirer.consequence": "Le profil ne peut plus être attribué ; sa version publiée passe au retrait.",
  "v2.profils.fiche.retirer.echec": "Le profil n’a pas été retiré.",
  "v2.profils.fiche.retirer.reversibilite": "Ses versions restent consultables dans l’historique.",
  "v2.profils.fiche.retirer.titre": "Retirer le profil {{nom}} ?",
  "v2.profils.fiche.retirer.verbe": "Retirer",
  "v2.profils.fiche.tenu": "Tenu par des personnes : retirez-le d’abord.",
  "v2.profils.fiche.titre": "Profil — fiche",
  "v2.profils.fiche.tous": "Tous les profils",
  "v2.profils.fiche.version": "Version {{n}}",
  "v2.profils.fiche.version.auteur": "auteur {{qui}}",
  "v2.profils.fiche.version.auto": "auto-approuvée",
  "v2.profils.fiche.version.publie_le": "publiée le {{date}}",
  "v2.profils.fiche.version.validateur": "validée par {{qui}} le {{date}}",
  "v2.profils.fiche.version_a_publier": "Ouvrir la version à publier",
  "v2.profils.fiche.versions": "Versions",
  "v2.profils.fiche.versions.vide": "Aucune version.",
  "v2.profils.filtre.niveau": "Niveau",
  "v2.profils.filtre.origine": "Origine",
  "v2.profils.filtre.soumissions": "Mes soumissions",
  "v2.profils.geste.en_cours": "En cours…",
  "v2.profils.heritage.profil_d_administration_qui_descend_jamais_surcharge": "Profil d’administration : il descend vers les programmes et les projets et n’y est jamais remplacé.",
  "v2.profils.heritage.profil_de_travail_restreint_plus_bas": "Profil de travail : un profil posé plus bas le remplace sur cet espace.",
  "v2.profils.isoles": "Droits isolés en vigueur",
  "v2.profils.isoles.col.droit": "Droit",
  "v2.profils.isoles.col.ecart": "Écart",
  "v2.profils.isoles.col.echeance": "Date de fin",
  "v2.profils.isoles.col.objet": "Sur",
  "v2.profils.isoles.col.personne": "Personne",
  "v2.profils.isoles.confirmer.consequence": "Le droit {{droit}} sur {{objet}} cesse d’être effectif ; il reste dans l’historique.",
  "v2.profils.isoles.confirmer.reversibilite": "Le droit peut être accordé de nouveau.",
  "v2.profils.isoles.confirmer.titre": "Retirer le droit isolé de {{qui}} ?",
  "v2.profils.isoles.ecart": "Écart signalé",
  "v2.profils.isoles.echeance": "Jusqu’au {{date}}",
  "v2.profils.isoles.echec": "Le droit isolé n’a pas été retiré.",
  "v2.profils.isoles.etat.en_vigueur": "En vigueur",
  "v2.profils.isoles.etat.expire": "Expiré",
  "v2.profils.isoles.etat.expire_bientot": "Expire bientôt",
  "v2.profils.isoles.retire": "Droit isolé retiré.",
  "v2.profils.isoles.retirer": "Retirer",
  "v2.profils.isoles.retirer.nom": "Retirer le droit isolé de {{qui}}",
  "v2.profils.isoles.retirer.nom_programme": "Retirer le droit isolé de {{qui}} sur le programme {{objet}}",
  "v2.profils.isoles.retirer.nom_projet": "Retirer le droit isolé de {{qui}} sur le projet {{objet}}",
  "v2.profils.isoles.sans_fin": "Sans date de fin",
  "v2.profils.isoles.vide": "Aucun droit isolé en vigueur.",
  "v2.profils.isoles.voir_membre": "Voir le membre {{qui}}",
  "v2.profils.liste": "Profils",
  "v2.profils.liste.vide": "Aucun profil ne correspond à ces filtres.",
  "v2.profils.niveau.organisation": "Organisation",
  "v2.profils.niveau.plateforme": "Plateforme",
  "v2.profils.niveau.programme": "Programme",
  "v2.profils.niveau.projet": "Projet",
  "v2.profils.niveau.tous": "Tous les niveaux",
  "v2.profils.onglet.membres": "Membres",
  "v2.profils.onglet.profils": "Profils",
  "v2.profils.onglet.regles": "Règles d’accès",
  "v2.profils.onglet.revue": "Revue des refus",
  "v2.profils.onglets": "Accès de l’organisation",
  "v2.profils.origine.depart": "Profil de départ de la plateforme",
  "v2.profils.origine.organisation": "Profil de l’organisation",
  "v2.profils.origine.tous": "Toutes les origines",
  "v2.profils.recherche": "Rechercher un droit",
  "v2.profils.recherche.aide": "Un libellé ou un code de droit : les profils qui le tiennent.",
  "v2.profils.recherche.deux_caracteres": "Saisissez au moins 2 caractères.",
  "v2.profils.recherche.effacer": "Effacer la recherche",
  "v2.profils.recherche.qui_le_tiennent": "Profils qui tiennent ce droit.",
  "v2.profils.sans_organisation": "Aucune organisation dans la session.",
  "v2.profils.soumissions.brouillons": "Mes brouillons",
  "v2.profils.soumissions.en_validation": "Mes soumissions en validation",
  "v2.profils.soumissions.refusees": "Mes soumissions refusées",
  "v2.profils.soumissions.toutes": "Toutes",
  "v2.profils.titre": "Profils de l’organisation",
  "v2.profils.voir": "Voir",
  "v2.profils.voir.nom": "Voir le profil {{nom}}"
}
